import React, { useEffect, useState } from "react";
import TopContentCampaign from "../../components/user/Campaign/CampaignContentComponents/TopContentCampaign";
import MiddleContentCampaign from "../../components/user/Campaign/CampaignContentComponents/MiddleContentCampaign";
import LastContentCampaign from "../../components/user/Campaign/CampaignContentComponents/LastContentCampaign";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import CampaignSkeletonLoader from "../../components/user/Campaign/CampaignSkeletonLoader";
import ServiceDonationProcess from "../../components/Service/ServiceDonation/ServiceDonationProcess";
import BreadcrumbBanner from "../../components/common/BreadcrumbBanner";
import hand_rise_banner from "../../Assets/Images/hand_rise_banner.png";
import DonationProcess from "../../components/user/Dontations/DonationProcess";
import ItineraryContentCampaign from "../../components/user/Campaign/CampaignContentComponents/ItineraryContentCampaign";
// import NavigationBanner from "../../components/common/NavigationBanner";
// import DonationProcess from "../../components/user/Campaign/CampaignDonation/DonationProcess";

const Campaign = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [campaign, setCampaign] = useState([]);

  useEffect(() => {
    const getCampaignData = async () => {
      try {
        const response = await axiosInstance.get(
          `/campaigns/campaign-by-id/${id}`,
        );
        setCampaign(response.data);
        console.log("response", response);
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      } finally {
        setLoading(false);
      }
    };
    window.scrollTo({ top: 0, behavior: "smooth" });
    getCampaignData();
  }, [id]);

  if (loading) return <CampaignSkeletonLoader />;

  return (
    <>
      {/* <NavigationBanner
        title={"Explore Campaigns"}
        background={assets.hand_rise_banner}
      /> */}

      <BreadcrumbBanner background={hand_rise_banner} title={campaign?.name} />

      <div className="flex flex-col lg:flex-row w-full justify-center gap-6 md:px-[3.5rem] px-4 py-6">
        {/* Left Section */}
        <div className="w-full lg:w-[65%] xl:w-[70%]">
          <TopContentCampaign
            banner_images={campaign.images}
            logo={campaign.logo}
            title={campaign.name}
            description={campaign.description}
            location={campaign.location}
            date={campaign.date}
            isSignificant={campaign.isSignificant}
          />
          <ItineraryContentCampaign
            itinerary={campaign.itinerary}
            isSignificant={campaign.isSignificant}
          />
          <MiddleContentCampaign shortInfo={campaign.shortInfo} />
          <LastContentCampaign campaign={campaign} />
        </div>

        {/* Right Section (Sticky Donation Box) */}
        <div className="w-full lg:w-[35%] xl:w-[30%]">
          <div className="sticky top-40">
            <DonationProcess type="Campaigns" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Campaign;
